export default (record1, record2) => {
  if (record1?.active === record2?.active) {
    return 0
  } if (record1?.active === true) {
    return -1
  }
  return 1;
}
